export default "__VITE_ASSET__9bfd6d59__"